import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { List, Map } from 'immutable';
import { range } from 'lodash';

import BetTickerBox from './BetTickerBox.jsx';
class BetTicker extends React.Component {
    static propTypes = {
        layouts: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.number)),
        layoutProp: PropTypes.string,
        competitions: ImmutablePropTypes.list,
        sports: ImmutablePropTypes.list,
        betTicker: ImmutablePropTypes.map,

        onGetSportsRequest: PropTypes.func.isRequired,
        onQueryCompetitionsRequest: PropTypes.func.isRequired,
        onGetBets: PropTypes.func.isRequired,
        onGetRejectedBets: PropTypes.func.isRequired,
        onGetSettledBets: PropTypes.func.isRequired,
        routeToANewTab: PropTypes.func.isRequired
    };

    static defaultProps = {
        layouts: [
            [ 1 ],
            [ 2 ],
            [ 2, 1 ],
            [ 2, 2 ]
        ],
        competitions: List(),
        sports: List(),
        betTicker: Map()
    };

    constructor(props, context) {
        super(props, context);

        this.state = {
            layout: null
        };
    }

    UNSAFE_componentWillMount() {
        this.props.onGetSportsRequest();
        this.props.onGetBets();
        this.props.onGetRejectedBets();
        this.props.onGetSettledBets();

        const { layoutProp } = this.props;
        if (layoutProp) {
            const layout = layoutProp.split(',').map(elem => parseInt(elem, 10));
            this.setState({
                layout
            });
        }
    }

    setLayout(layout, e) {
        if (e) {
            e.preventDefault();
        }

        return this.props.routeToANewTab(layout);
    }

    render() {
        const { layout } = this.state;
        const { layouts, sports, competitions, betTicker } = this.props;
        let content;
        if (layout) {
            content = (
                <div className={ `bet-ticker-content bet-ticker--layout-${layout.join( '-' )}` }>
                    {
                        layout.map((row, rowId) => (
                            <div className='row' key={ rowId } style={{ height: `${100 / layout.length }%` }}>
                                {
                                    range(0, row).map((x, idx) => (
                                        <div className={ `col-${ 12 / row}` } key={ idx }>
                                            <BetTickerBox
                                                sports={ sports }
                                                competitions={ competitions }
                                                data={ betTicker }
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                        ))
                    }
                </div>
            );
        } else {
            content = (
                <ul className='bet-ticker-layouts' data-test='layout-view'>
                    {
                        layouts.map((l, idx) => (
                            <li key={ idx }>
                                <a href='#' onClick={ this.setLayout.bind(this, l) }>
                                    { l.reduce((c, v) => c + v, 0) }
                                </a>
                            </li>
                        ))
                    }
                </ul>
            );
        }

        return (
            <div className='bet-ticker'>
                { content }
            </div>
        );
    }

}

export default BetTicker;
